module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black d-flex px-3"
  }, [_c('div', {
    staticClass: "col-md-2 text-center p-0 align-middle h-100 mr-2"
  }, [_c('img', {
    attrs: {
      "src": "static/images/dashboard/tasksCompletedSmile.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 fc-dark align-middle h-100"
  }, [_c('div', {
    staticClass: "font-weight-600 fs-large mb-2"
  }, [_vm._v("Well Done.")]), _vm._v(" "), _c('div', [_vm._v("You can now see your operation business"), _c('br'), _vm._v(" operation feed. Start selling some products.")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-db657e42", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db657e42"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardTaskscompleted.vue
// module id = 1521
// module chunks = 0